import { createServiceAxios } from "./lib/awAxios";
import { EnvJson } from "./uimanager/EnvJson";
import { Menus } from "./uimanager/Menus";
import { Modules } from "./uimanager/Modules";
import { Pages } from "./uimanager/Pages";
import { Views } from "./uimanager/Views";

// Create independent Client for Uimanager service
const umClient = createServiceAxios("uimanager");
export const UM_SERVICE = {
  views: new Views(umClient),
  envJson: new EnvJson(umClient),
  pages: new Pages(umClient),
  modules: new Modules(umClient),
  menus: new Menus(umClient),
};

const tmClient = createServiceAxios("tm");
export const TM_SERVICE = {
  instance: tmClient.instance,
};
